import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLiterals } from '@/core/lang';

let lang;

if (
	window.Telegram.WebApp.platform === 'android' ||
	window.Telegram.WebApp.platform === 'ios' ||
	window.Telegram.WebApp.platform === 'android_x' ||
	process.env.VITE_ENV_APP === 'dev' ||
	process.env.VITE_ENV_APP === 'int'
) {
	lang = localStorage.getItem('lang_selected');
} else {
	window.Telegram.WebApp.CloudStorage.getItem('lang_selected', (_, res) => {
		lang = res;
	});
}

const getClientLiterals = async () => {
	return await getLiterals();
};

i18n.use(initReactI18next).init({
	lng: lang ? lang : process.env.VITE_DEFAULT_LANGUAGE,
	fallbackLng: process.env.VITE_DEFAULT_LANGUAGE,
	interpolation: {
		escapeValue: false,
	},
	resources: await getClientLiterals(),
});

export default i18n;
